import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import { siteConfig } from "@/config/siteConfig";
import tp1 from "@/assets/Third-parties/TP1.png";
import tp2 from "@/assets/Third-parties/TP2.png";
import tp3 from "@/assets/Third-parties/TP3.png";
import tp4 from "@/assets/Third-parties/TP4.png";
import tp5 from "@/assets/Third-parties/TP5.png";
import tp6 from "@/assets/Third-parties/TP6.png";

const imageMap = {
  "TP1.png": tp1,
  "TP2.png": tp2,
  "TP3.png": tp3,
  "TP4.png": tp4,
  "TP5.png": tp5,
  "TP6.png": tp6,
};

export function ThirdPartyPartners() {
  const partners = siteConfig.thirdPartyPartners
    .filter(partner => partner.url)
    .map(partner => ({
      ...partner,
      image: imageMap[partner.image as keyof typeof imageMap]
    }));

  return (
    <section className="section-padding bg-secondary/30 relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-12 animate-fade-in-up">
          <div className="inline-block px-4 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
            Booking Partners
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-6">
            Book at these <span className="text-gradient">Third-Parties</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            Booking can be made at the following Third-Parties
          </p>
        </div>

        <div className="max-w-5xl mx-auto animate-fade-in-up animation-delay-200">
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            plugins={[
              Autoplay({
                delay: 3000,
              }),
            ]}
            className="w-full"
          >
            <CarouselContent className="-ml-2 md:-ml-4">
              {partners.map((partner) => (
                <CarouselItem key={partner.id} className="pl-2 md:pl-4 basis-1/2 md:basis-1/3 lg:basis-1/4">
                  <div className="p-1">
                    <a
                      href={partner.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block bg-card rounded-xl border border-border/50 p-6 flex items-center justify-center h-32 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/10 transition-all duration-300 group"
                    >
                      <img
                        src={partner.image}
                        alt={partner.name}
                        className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-110"
                      />
                    </a>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex" />
            <CarouselNext className="hidden md:flex" />
          </Carousel>
        </div>
      </div>
    </section>
  );
}
